import { makeStyles } from '@mui/styles'
import {
  MyAccountTheme,
  MyInsuranceFormObjectFieldTemplateClasses,
} from '@dxp-module/themes'

const objectFieldTemplateStyles = makeStyles<
  MyAccountTheme,
  object,
  MyInsuranceFormObjectFieldTemplateClasses
>(
  ({ typography }) => ({
    container: {
      padding: 0,
    },
    title: {
      fontWeight: typography.fontWeightBold,
      margin: '30px 0 15px',
    },
  }),
  { name: 'MyAccount_InsuranceForm_ObjectFieldTemplate' }
)

export default objectFieldTemplateStyles
